export default "__VITE_ASSET__202b601e__"